import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { UtilityService } from 'src/app/core/services/utility.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { HelperService } from 'src/app/core/services/helper.service';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { DocumentViewerComponent } from '../document-viewer/document-viewer.component';
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { checkCBSEGr8 } from '@app-helpers/functions';

@Component({
  selector: 'app-class-list-card',
  templateUrl: './class-list-card.component.html',
  styleUrls: ['./class-list-card.component.css'],
})
export class ClassListCardComponent implements OnInit, OnChanges {
  @Input() type: any;
  @Input() classData: any;
  @Input() dataType: any;
  @Input() index: number;

  private viewerDialog: any = null;
  @Output() refreshData: EventEmitter<any> = new EventEmitter<any>();

  isToday = false;
  isTomorrow = false;

  public errImgTry: number = 0;
  public errImgMaxTry: number = 5;
  detailsClass: string = 'hide';
  detailsIndex: number;
  showScience: boolean = false;
  constructor(private dialog: MatDialog, public _helper: HelperService) {}

  ngOnInit(): void {
    this.statusCheck();
    this.showScience = checkCBSEGr8();
  }

  ngOnChanges(_changes: SimpleChanges): void {
  }

  previewDocument = (_item: any) => {
    const config: MatDialogConfig = {
      data: {
        item: _item,
        isDocuments: true,
        isDownloadable: true,
      },
      disableClose: true,
      scrollStrategy: new NoopScrollStrategy(),
      panelClass: 'doc-viewer-popup',
    };

    this.viewerDialog = this.dialog.open(DocumentViewerComponent, config);

    this.viewerDialog.afterOpened().subscribe(() => {
      document.body.classList.add('modal-open');
    });

    this.viewerDialog.afterClosed().subscribe((res: any) => {
      document.body.classList.remove('modal-open');
    });
  };

  openCourseCurriculum = (_item: any) => {
    const config: MatDialogConfig = {
      data: _item.src,
      disableClose: false,
      scrollStrategy: new NoopScrollStrategy(),
    };
    const dialogRef = this.dialog.open(PdfViewerComponent, config);
    dialogRef.afterOpened().subscribe(() => {
      document.body.classList.add('modal-open');
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      document.body.classList.remove('modal-open');
    });
  };

  statusCheck() {
    if (this.dataType == 'course') {
      this.type = UtilityService.classType(
        this.classData.serverTime,
        this.classData?.obj?.startTime,
        this.classData?.obj?.endTime,
        this.classData?.obj?.meetingStatus
      );
    }
    this.isToday = UtilityService.isToday(this.classData.schedule.startDate, this.classData.schedule.serverTime);
    if (!this.isToday) {
      this.isTomorrow = UtilityService.isTomorrow(
        this.classData.schedule.startDate,
        this.classData.schedule.serverTime
      );
    }
  }

  showHideDetails(val, index) {
    this.detailsClass = val;
    this.detailsIndex = index;
  }
}
